import React, { useEffect, useState } from "react";
import { FaTimes, FaUpload, FaInfoCircle, FaMapMarkerAlt, FaUser, FaFileSignature } from "react-icons/fa";
import styles from "../../styles/applicant/ApplicantZoneForm.module.css";
import PaymentModal from "./PaymentModal.js";
import PaymentReceipt from "./PaymentReceiptZ.js";

const ApplicantZoneForm = ({ closeForm }) => {
  const [formData, setFormData] = useState({
    division: "Pune",
    district: "Sangli",
    taluka: "Sangli",
    village: "",
    questions1: "",
    applicantName: "",
    applicantAddress: "",
    applicantMobile: "",
    applicantEmail: "",
    surveyNumber: "",
    area: "",
    attachment_pr_satbara: null,
    attachment_MeasurementSheet: null,
    declaration: false,
    paymentAgreement: false,
    formType: "Zone",
    PropertyNumberType: "",
  });

  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const savedLang = localStorage.getItem("preferredLanguage") || "en";
  const [showModal, setShowModal] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  const propertyNumberType = [
    "Survey Number (सर्व्हे क्रमांक)",
    "City Survey Number (शहर सर्व्हे क्रमांक)"
  ];

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_applicant_profile.php`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          credentials: 'include'
        });
        const result = await response.json();

        if (result.status === "success") {
          setFormData(prev => ({
            ...prev,
            applicantName: result.full_name || "",
            applicantAddress: result.profile?.address || "",
            applicantMobile: result.profile?.phone || "",
            applicantEmail: result.profile?.email || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    getProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

    if (files && files.length > 0) {
      const fileType = files[0].type;
      if (!allowedTypes.includes(fileType)) {
        alert('Only PDF, JPG, JPEG, and PNG files are allowed.');
        return;
      }
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  // payment window pop up - EXACT WORKING VERSION
  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowLoader(true);

    const submissionData = new FormData();

    // Add all form data
    for (const key in formData) {
      if (key === 'attachment_pr_satbara' || key === 'attachment_MeasurementSheet') {
        if (formData[key]) submissionData.append(key, formData[key]);
      } else {
        submissionData.append(key, formData[key]);
      }
    }

    submissionData.append("certification_name", "Zone");
    submissionData.append("paymentMethod", "online");
    submissionData.append("applicantEmail", formData.applicantEmail);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/form_submit_tempory.php`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
        body: submissionData,
      });

      const result = await response.json();

      if (result.status === "success") {
        setFormData(prev => ({
          ...prev,
          request_unique_id: result.request_unique_id || "",
        }));
        setShowPaymentPopup(true);
        console.log(result);
      } else {
        alert("Failed to submit form: " + result.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form.");
    } finally {
      setShowLoader(false);
    }
  };

  const handleSuccessClose = async () => {
    try {
      setPaymentDetails({
        method: "Online",
        amount: "1.00",
        transactionId: formData.request_unique_id || "",
        receiptNumber: `REC${Date.now().toString().slice(-8)}`
      });
      setShowSuccessPopup(false);
      setShowReceipt(true);
    } catch (error) {
      console.error("Error handling success:", error);
      setShowSuccessPopup(false);
      setShowReceipt(true);
    }
  };

  const handleReceiptDownloadComplete = () => {
    setShowReceipt(false);
    closeForm();
    window.location.reload();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.formContainer}>
        <div className={styles.header}>
          <div>
            <h2>
              {savedLang === "mr"
                ? "क्षेत्र प्रमाणपत्र अर्ज"
                : "Zone Certificate Application"}
            </h2>
            <p className={styles.subtitle}>
              {savedLang === "mr"
                ? "आपल्या मालमत्तेसाठी झोनिंग अर्ज सादर करा"
                : "Request for zoning Application to your property"}
            </p>
          </div>
          <button
            className={styles.closeButton}
            onClick={closeForm}
            aria-label="Close form"
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.grid}>
            <div className={styles.column}>
              <div className={styles.sectionHeader}>
                <FaMapMarkerAlt className={styles.sectionIcon} />
                <h3>
                  {savedLang === "mr" ? "स्थान तपशील" : "Location Details"}
                </h3>
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "मालमत्ता क्रमांक प्रकार" : "Property Number Type"}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <select
                  name="PropertyNumberType"
                  value={formData.PropertyNumberType}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    {savedLang === "mr" ? "प्रकार निवडा" : "Select Type"}
                  </option>
                  {propertyNumberType.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.fileUploadLabel}>
                  <span>
                    {savedLang === "mr"
                      ? "७/१२ उतारा / सी.टी. सर्वे / गुठेवारी प्रमाणपत्र"
                      : "7/12 Extract / C.T. Survey / Gunthewari Certificate (with Old & New Survey Numbers)"}
                    <span className={styles.required}>*</span>
                  </span>
                  <div className={styles.fileUploadWrapper}>
                    <input
                      type="file"
                      name="attachment_pr_satbara"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleChange}
                      className={styles.fileInput}
                      required
                    />
                    <div className={styles.fileUploadButton}>
                      <FaUpload className={styles.uploadIcon} />
                      <span>
                        {formData.attachment_pr_satbara
                          ? formData.attachment_pr_satbara.name
                          : savedLang === "mr"
                            ? "फाईल निवडा"
                            : "Choose file"}
                      </span>
                    </div>
                  </div>
                  {formData.attachment_pr_satbara && (
                    <div className={styles.fileInfo}>
                      <FaInfoCircle className={styles.infoIcon} />
                      <span>
                        {savedLang === "mr" ? "निवडलेले:" : "Selected:"}{" "}
                        {formData.attachment_pr_satbara.name}
                      </span>
                    </div>
                  )}
                </label>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.fileUploadLabel}>
                  <span>
                    {savedLang === "mr"
                      ? "मोजणी पत्रक (जमिनीचा उतारा)"
                      : "Measurement Sheet / C.T. Survey Map / Layout / Gunthewari Plot Map"}
                    <span className={styles.required}>*</span>
                  </span>
                  <div className={styles.fileUploadWrapper}>
                    <input
                      type="file"
                      name="attachment_MeasurementSheet"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleChange}
                      className={styles.fileInput}
                      required
                    />
                    <div className={styles.fileUploadButton}>
                      <FaUpload className={styles.uploadIcon} />
                      <span>
                        {formData.attachment_MeasurementSheet
                          ? formData.attachment_MeasurementSheet.name
                          : savedLang === "mr"
                            ? "फाईल निवडा"
                            : "Choose file"}
                      </span>
                    </div>
                  </div>
                  {formData.attachment_MeasurementSheet && (
                    <div className={styles.fileInfo}>
                      <FaInfoCircle className={styles.infoIcon} />
                      <span>
                        {savedLang === "mr" ? "निवडलेले:" : "Selected:"}{" "}
                        {formData.attachment_MeasurementSheet.name}
                      </span>
                    </div>
                  )}
                </label>
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "सर्व्हे क्र." : "CTS / Gat / Survey No. / TPS No. / Area Name"}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <input
                  className={styles.impfix1}
                  type="text"
                  name="surveyNumber"
                  placeholder={
                    savedLang === "mr"
                      ? "सर्व्हे क्रमांक भरा"
                      : "Enter survey number"
                  }
                  value={formData.surveyNumber}
                  onChange={handleChange}
                  required
                />
              </div>



              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "गाव निवडा" : "Select Village Area"}{" "}
                  <span className={styles.required}>*</span>
                </label>

                <select
                  name="questions1"
                  value={formData.questions1}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    {savedLang === "mr" ? "गाव निवडा" : "Select Village Area"}
                  </option>
                  <option value="Sangli">Sangli</option>
                  <option value="Miraj">Miraj</option>
                  <option value="Kupwad">Kupwad</option>
                </select>
              </div>


            </div>

            <div className={styles.column}>
              <div className={styles.sectionHeader}>
                <FaUser className={styles.sectionIcon} />
                <h3>
                  {savedLang === "mr" ? "अर्जदाराची माहिती" : "Applicant Details"}
                </h3>
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "नाव" : "Name"}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantName"
                  value={formData.applicantName}
                  readOnly
                  className={styles.readOnlyInput}
                />
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "मोबाईल क्र." : "Mobile No."}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantMobile"
                  value={formData.applicantMobile}
                  readOnly
                  className={styles.readOnlyInput}
                />
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "ईमेल" : "Email"}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <input
                  type="email"
                  name="applicantEmail"
                  value={formData.applicantEmail}
                  readOnly
                  className={styles.readOnlyInput}
                />
              </div>

              <div className={styles.formGroup}>
                <label>
                  {savedLang === "mr" ? "पत्ता" : "Address"}{" "}
                  <span className={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantAddress"
                  placeholder={
                    savedLang === "mr"
                      ? "पूर्ण पत्ता भरा"
                      : "Enter complete address"
                  }
                  value={formData.applicantAddress}
                  onChange={handleChange}
                  required
                  className={styles.textInput}
                />
              </div>
            </div>
          </div>

          <div className={styles.agreementSection}>
            <div className={styles.sectionHeader}>
              <FaFileSignature className={styles.sectionIcon} />
              <h3>{savedLang === "mr" ? "घोषणापत्रे" : "Declarations"}</h3>
            </div>

            <div className={styles.checkboxGroup}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={handleChange}
                  required
                  className={styles.checkboxInput}
                />
                <span className={styles.checkboxCustom}></span>
                {savedLang === "mr"
                  ? "मी दिलेली माहिती योग्य असल्याचे घोषित करतो."
                  : "I declare that the provided information is correct to the best of my knowledge."}
              </label>

              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="paymentAgreement"
                  checked={formData.paymentAgreement}
                  onChange={handleChange}
                  required
                  className={styles.checkboxInput}
                />
                <span className={styles.checkboxCustom}></span>
                {savedLang === "mr"
                  ? "मी या प्रक्रियेसाठी आवश्यक शुल्क भरण्यास सहमत आहे."
                  : "I agree to pay the required fee for this process."}
              </label>
            </div>
          </div>

          <div className={styles.buttonGroup}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={closeForm}
              disabled={isSubmitting}
            >
              {savedLang === "mr" ? "रद्द करा" : "Cancel"}
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className={styles.spinner}></span>
              ) : savedLang === "mr" ? (
                "सत्यापित करा आणि पेमेंटसाठी पुढे जा"
              ) : (
                "Confirm and Proceed to payment"
              )}
            </button>
          </div>
        </form>
      </div>

      {showPaymentPopup && (
        <div className={styles.paymentPopupOverlay}>
          <div className={styles.paymentPopup}>
            <PaymentModal
              show={showModal}
              onClose={() => setShowModal(false)}
              formData={formData}
              setShowSuccessPopup={(paymentResponse) => {
                console.log("Payment response callback:", paymentResponse);

                if (paymentResponse) {
                  if (typeof paymentResponse === 'object') {
                    setPaymentDetails({
                      method: "Online",
                      amount: paymentResponse.amount || "1.00",
                      transactionId: paymentResponse.request_unique_id || "",
                      tracking_id: paymentResponse.tracking_id || "",
                      bank_ref_no: paymentResponse.bank_ref_no || "",
                      payment_mode: paymentResponse.payment_mode || "",
                      trans_fee: paymentResponse.trans_fee || "0.00",
                      service_tax: paymentResponse.service_tax || "0.00",
                      status: paymentResponse.status || "Success",
                      receiptNumber: `REC${Date.now().toString().slice(-8)}`
                    });
                    setShowSuccessPopup(true);
                  } else if (paymentResponse === true) {
                    setPaymentDetails({
                      method: "Online",
                      amount: "1.00",
                      transactionId: formData.request_unique_id || "",
                      receiptNumber: `REC${Date.now().toString().slice(-8)}`,
                      status: "Success"
                    });
                    setShowSuccessPopup(true);
                  }
                } else {
                  setPaymentDetails({
                    method: "Online",
                    amount: "1.00",
                    transactionId: formData.request_unique_id || "",
                    receiptNumber: `REC${Date.now().toString().slice(-8)}`,
                    status: "Success"
                  });
                  setShowSuccessPopup(true);
                }
              }}
            />
          </div>
        </div>
      )}

      {showLoader && (
        <div className={styles.loaderOverlay}>
          <div className={styles.loaderContent}>
            <div className={styles.loader}></div>
            <div className={styles.loaderText}>
              {savedLang === "mr"
                ? "कृपया प्रतीक्षा करा, आपला अर्ज सबमिट केला जात आहे..."
                : "Please wait, your application is being submitted..."}
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className={styles.successPopupOverlay}>
          <div className={styles.successPopup}>
            <div className={styles.successIcon}>
              <svg viewBox="0 0 24 24">
                <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
              </svg>
            </div>
            <h3>Payment Successful!</h3>
            <p>Your application has been submitted successfully.</p>
            <p>A receipt will be downloaded automatically when you close this popup.</p>
            <button
              className={styles.successButton}
              onClick={handleSuccessClose}
            >
              Close & Download Receipt
            </button>
          </div>
        </div>
      )}

      {showReceipt && (
        <PaymentReceipt
          formData={formData}
          paymentDetails={paymentDetails}
          onDownloadComplete={handleReceiptDownloadComplete}
        />
      )}
    </div>
  );
};

export default ApplicantZoneForm;